import { createGlobalStyle } from 'styled-components';
import { palette } from 'styled-theme';
import { device } from '@jjj/components';

export const GlobalStyle = createGlobalStyle`
  .remove-holiday-pricing-modal {
    .ant-modal-body {
      padding: 30px 40px !important;
    }

    .ant-modal-confirm-content {
      margin-top: 15px !important;
    }
  }

  .custom-scrollbar-thin {
    /* Custom WebKit Scrollbar */
    &::-webkit-scrollbar {
      width: 3px; /* Set the width of the scrollbar */
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: ${palette('grayscale', 3)}; /* Set the background color of the track */
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      border-radius: 5px; /* Set the border-radius of the scrollbar handle */
      background: ${palette('grayscale', 2)}; /* Set the color of the scrollbar handle */
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: ${palette('grayscale', 2)}; /* Set the color of the scrollbar handle on hover */
    }
  }

  .fulfilled {
    align-items: center;
    border-radius: 3px;
    color: ${palette('jobFulFillmentColors', 0)};
    background-color: ${palette('jobFulFillmentColors', 1)};
    display: inline-flex;
    font-family: Helvetica;
    font-size: 12px;
    font-weight: bold;
    height: 22px;
    justify-content: center;
    min-width: 90px;
    margin: 0 1px;
  }

  .fulfilled {
    &.fulfilled-multi {
      min-width: 45px;
    }

    &.fulfilled-col-100 {
      color: ${palette('jobFulFillmentColors', 2)};
      background-color: ${palette('jobFulFillmentColors', 3)};
    }

    &.fulfilled-col-75-99 {
      color: ${palette('jobFulFillmentColors', 4)};
      background-color: ${palette('jobFulFillmentColors', 5)};
    }

    &.fulfilled-col-50-74 {
      color: ${palette('jobFulFillmentColors', 6)};
      background-color: ${palette('jobFulFillmentColors', 7)};
    }

    &.fulfilled-col-0-49 {
      color: ${palette('jobFulFillmentColors', 8)};
      background-color: ${palette('jobFulFillmentColors', 9)};
    }

    &.fulfilled-col-canceled {
      color: ${palette('jobFulFillmentColors', 0)};
      background-color: ${palette('jobFulFillmentColors', 1)};
    }
  }

  body {
    background: transparent !important;
    margin: 0 !important;
    max-width: 100% !important;
    white-space: initial !important;
  }

  .isoUser > div > span {
    display: flex;
    flex-wrap: nowrap;
    height: 35px !important;
    align-items: center;

    .user-name {
      display: flex;
      display: none;

      .anticon {
        padding: 2px 0 0 4px;
      }
    }
  }

  .isomorphicTopbar .isoRight li.isoUser .isoImgWrapper img {
    cursor: pointer;
  }

  .ant-popover.ant-popover-placement-bottom
    > .ant-popover-content
    .ant-popover-inner-content
    .checkbox-form-item.popover-label
    label {
      color: ${palette('secondary', 0)};
  }

  .ant-select-dropdown-menu-item-group-title {
    color: ${palette('grayscale', 0)};
    font-size: 14px;
  }

  .actions-item-popover {
    .ant-popover-content {
      .ant-popover-inner {
        .ant-popover-inner-content {
          padding: 12px 0;

          button,
          a {
            padding: 4px 14px !important;
          }
        }
      }
    }
  }

  .ant-picker-panel,
  .ant-picker-dropdown,
  .ant-select-dropdown {
    z-index: 1075;
  }

  .ant-select-dropdown-menu-item.hidden {
    display: none;
  }

  .ant-table-row-level-0,
  .ant-table-row-level-1 {
    .ant-table-fixed-columns-in-body div {
      display: none;
    }
  }

  .animate-step-modal-width {
    .ant-modal {
      transition: width 300ms ease-in-out;
    }
  }

  .ant-table-cell-fix-right-first::after,
  .ant-table-cell-fix-right-last::after {
    box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);
  }

  .phone-input-dropdown-element {
    .ant-select-item-option-content {
      .phone-input-dropdown-element-details {
        display: flex;
        margin-left: 10px;
        margin-right: 0;
        align-items: center;
      }
    }
  }

  html[dir='rtl'] .phone-input-dropdown-element {
    .ant-select-item-option-content {
      .phone-input-dropdown-element-details {
        margin-left: 0;
        margin-right: 10px;
      }
    }
  }

  // JJJ custom overrides
  .jjj-org {
    // inputs/selects
    .ant-input:not(.ant-input-disabled), .ant-input-affix-wrapper,
    .ant-picker:not(.date-picker-without-background),
    .ant-legacy-form-item-control:not(.has-error)
      .ant-select-single.ant-select:not(.ant-select-disabled) .ant-select-selector,
    .ant-legacy-form-item-control:not(.has-error)
    .ant-input-number:not(.disabled):not(.ant-input-number-disabled) .ant-input-number-input,
    .form-group .currency-input:not(.overwrite):not(:disabled),
    .ant-picker:not(.ant-picker-disabled):not(.date-picker-without-background) .ant-picker-input,
    .ant-select .ant-select-selection.ant-select-selection--single .ant-select-selection__rendered .ant-input,
    .rdw-editor-main,
    .ant-legacy-form-item-control .form-group .input-masked-form-item:not(.has-error):not(.input-with-error)
    {
      background-color: ${palette('jjj', 0)} !important;

      &:hover:not(.ant-input-disabled):not(.ant-picker-disabled), &:focus {
        background-color: ${palette('jjj', 1)} !important;

        .ant-picker-input {
          background-color: ${palette('jjj', 1)} !important;
        }
      }
    }

    .ant-legacy-form-item-control:not(.has-error):hover .ant-select-selector
      .ant-select-selection-search input.ant-select-selection-search-input
    .phone-input-with-dropdown:hover div .ant-select-single.ant-select:not(.ant-select-disabled) .ant-select-selector,
    .phone-input-with-dropdown:hover div .ant-legacy-form-item-control .input-masked-form-item,
    .phone-input-with-dropdown:hover div .ant-legacy-form-item-control .ant-select-selector,
    .phone-input-with-dropdown:hover div .ant-legacy-form-item-control:not(.has-error)
      .ant-select-single.ant-select:not(.ant-select-disabled) .ant-select-selector,
    .ant-input-affix-wrapper-focused {
      background-color: ${palette('jjj', 1)} !important;
    }

    .time-picker-dropdown-element .ant-picker-panel-container,
    .ant-select-dropdown {
      background-color: ${palette('jjj', 0)} !important;
    }

    .phone-input-with-dropdown .ant-legacy-form-item-control .ant-select-selector .ant-select-selection-search-input {
      background-color: transparent !important;
    }

    .time-picker-dropdown-element .ant-picker-panel-container .ant-picker-time-panel-column >
      .ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner,
    .ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover,
    .ant-select-item-option-active,
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        background-color: ${palette('jjj', 1)} !important;
      }

    .ant-input-affix-wrapper:hover input.ant-input,
    .time-picker-dropdown-element .ant-btn-primary {
      background-color: ${palette('jjj', 1)} !important;

      &:hover, &:focus {
        background-color: ${palette('jjj', 1)} !important;
      }
    }
  }

  // BENCH custom overrides
  .bench-org {
    // filter pills
    .filter-pill.filter-pill--active, .filter-pill:hover.filter-pill--active:hover {
      background-color: ${palette('primary', 0)} !important;
    }
  }

  // SSA custom overrides
  .ssa-org {
    // footer links
    footer.ant-layout-footer .link-container a {
      color: ${palette('primary', 0)} !important;
    }
  }

  // MAOF custom overrides
  .maof-org {
    // inputs/selects
    .ant-input:not(.ant-input-disabled), .ant-input-affix-wrapper,
    .ant-picker:not(.date-picker-without-background),
    .ant-legacy-form-item-control:not(.has-error)
      .ant-select-single.ant-select:not(.ant-select-disabled) .ant-select-selector,
    .ant-legacy-form-item-control:not(.has-error)
    .ant-input-number:not(.disabled):not(.ant-input-number-disabled) .ant-input-number-input,
    .form-group .currency-input:not(.overwrite):not(:disabled),
    .ant-picker:not(.ant-picker-disabled):not(.date-picker-without-background) .ant-picker-input,
    .ant-select .ant-select-selection.ant-select-selection--single .ant-select-selection__rendered .ant-input,
    .rdw-editor-main,
    .ant-legacy-form-item-control .form-group .input-masked-form-item:not(.has-error):not(.input-with-error)
    {
      background-color: ${palette('maof', 0)} !important;

      &:hover:not(.ant-input-disabled), &:focus {
        background-color: ${palette('maof', 1)} !important;
      }
    }

    .ant-legacy-form-item-control:not(.has-error):hover .ant-select-selector
      .ant-select-selection-search input.ant-select-selection-search-input
    .phone-input-with-dropdown:hover div .ant-select-single.ant-select:not(.ant-select-disabled) .ant-select-selector,
    .phone-input-with-dropdown:hover div .ant-legacy-form-item-control .input-masked-form-item,
    .phone-input-with-dropdown:hover div .ant-legacy-form-item-control .ant-select-selector,
    .phone-input-with-dropdown:hover div .ant-legacy-form-item-control:not(.has-error)
      .ant-select-single.ant-select:not(.ant-select-disabled) .ant-select-selector,
    .ant-input-affix-wrapper-focused {
      background-color: ${palette('jjj', 1)} !important;
    }

    .time-picker-dropdown-element .ant-picker-panel-container,
    .ant-select-dropdown {
      background-color: ${palette('maof', 0)} !important;
    }

    .phone-input-with-dropdown .ant-legacy-form-item-control .ant-select-selector .ant-select-selection-search-input {
      background-color: transparent !important;
    }

    .time-picker-dropdown-element .ant-picker-panel-container .ant-picker-time-panel-column >
      .ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner,
    .ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover,
    .ant-select-item-option-active,
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        background-color: ${palette('maof', 1)} !important;
      }

    .ant-input-affix-wrapper:hover input.ant-input,
    .time-picker-dropdown-element .ant-btn-primary {
      background-color: ${palette('maof', 1)} !important;

      &:hover, &:focus {
        background-color: ${palette('maof', 1)} !important;
      }
    }

    // Date picker
    .DayPicker-Day.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      background-color: ${palette('primary', 0)} !important;
    }

    // filter pills
    .filter-pill.filter-pill--active, .filter-pill:hover.filter-pill--active:hover {
      background-color: ${palette('primary', 0)} !important;
    }

    // footer links
    footer.ant-layout-footer .link-container a {
      color: ${palette('secondary', 0)} !important;
    }
  }

  .pending-items-custom-deny-button {
    background-color: blue !important;

    &.ant-btn.ant-btn-primary {
      background-color: ${palette('error', 0)} !important;
      color: ${palette('primary', 0)};

      &.ant-btn-sm {
        background-color: ${palette('error', 0)} !important;
        padding: 0 10px;
        height: 30px;
        font-size: 14px;
      }

      @media ${device.laptop} {
        &:hover {
          background-color: ${palette('error', 1)} !important;
        }

        &:active {
          background-color: ${palette('error', 1)} !important;
        }
      }
    }
  }
`;
